import React, { useState } from "react";
import { ReactComponent as Icshoppe } from "../../assets/icons/ic-shoppe.svg"
import {ReactComponent as IcTokped} from "../../assets/icons/ic-tokopedia.svg"
import {ReactComponent as IcFacebook} from "../../assets/icons/ri_facebook-fill.svg"
// import {ReactComponent as IcTwitter} from "../../assets/icons/prime_twitter.svg"
import {ReactComponent as IcInstagram} from "../../assets/icons/ri_instagram-fill.svg"
// import {ReactComponent as IcTiktok} from "../../assets/icons/ic_baseline-tiktok.svg"
import AgirosLogo from "../../assets/images/arigos-logo.png"
import  data  from '../../data/staticData'


export const Navbar = () => {
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const menu = [
    {
        name: "Abous Us",
        toScrool: 20
    },
    {
        name: "Why Agiros",
        toScrool: 50
    },
    {
        name: "Best Seller",
        toScrool: 65
    },
    {
        name: "Testimonials",
        toScrool: 85
    },
    {
        name: "Contact",
        toScrool: 100
    },
]
 const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
const scrollToPercentage = (percentage) => {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    window.scrollTo({
      top: (percentage / 100) * scrollHeight,
      behavior: "smooth",
    });
  };
 return (
  <>
      <div className="fixed w-full z-50 hidden md:block">
        <div className="flex items-center justify-between p-3 px-10 font-semibold text-sm text-white bg-[#437086] screen">
            <div className="flex items-center space-x-2">
                <h1>Tersedia di</h1>
                <div className="flex items-center space-x-2">
                    <div className="rounded-full p-1 bg-[#548CA8]">
                        <Icshoppe className='cursor-pointer' onClick={() => window.open(data.storeCredentials.shoppeeUrl)} />
                    </div>
                    <p>agirosparfum</p>
                </div>
                <div className="flex items-center space-x-2">
                    <div className="rounded-full p-1 bg-[#548CA8]">
                        <IcTokped className='cursor-pointer' onClick={() => window.open(data.storeCredentials.tokpedUrl)}/>
                    </div>
                    <p>agirosparfum</p>
                </div>
            </div>
            <div className="flex space-x-4">
                <IcFacebook className='cursor-pointer' onClick={() => window.open(data.storeCredentials.facebookUrl)}/>
                <IcInstagram className='cursor-pointer' onClick={() => window.open(data.storeCredentials.instagramUrl)} />
            </div>
        </div>
        <div className="flex justify-between items-center p-3 px-10 bg-white/30 backdrop-blur-md border-white/20">
            <img src={AgirosLogo} alt="Agiros Logo" />
            <div className="flex space-x-14 text-[#525252]">
                {menu.map((item, index) => (
                  <button 
                    key={index} 
                    onClick={() => scrollToPercentage(item.toScrool)}
                    className="hover:text-[#437086] transition-colors duration-200"
                  >
                    {item.name}
                  </button>
                ))}
            </div>
        </div>
      </div>

      <div className="fixed w-full z-50 md:hidden">
        <div className="flex justify-between items-center p-3 px-4 bg-white/30 backdrop-blur-md border-white/20">
          <img src={AgirosLogo} className="w-24" alt="Agiros Logo" />
          {/* <button
            onClick={toggleSidebar}
            className="text-[#437086] hover:text-[#548CA8] focus:outline-none p-2"
          >
            <div className="w-3 h-3 bg-slate-500" />
          </button> */}
        </div>
      </div>
  </>
 )
}